import React from "react";
import { connect } from "react-redux";
import actions from "./redux/actions";
import { log_error, getAuthorizationToken } from "./api";
import { showQueue, indexQueueMedia } from "./api/queues";

class QueueManager extends React.Component {
  initNextUp = async () => {
    try {
      let {
        data: { media }
      } = await indexQueueMedia({
        queue_offset: this.props.queue.current_track_index + 1
      });
      this.props.dispatch(actions.setNextUp(media));
      this.props.dispatch(actions.setLoadingMoreNextUp(false));
    } catch (error) {
      this.props.dispatch(actions.setLoadingMoreNextUp(false));
      console.log(log_error(error));
    }
  };
  initQueue = async () => {
    if (!getAuthorizationToken()) return;
    try {
      let { data } = await showQueue();
      this.props.dispatch(actions.setQueue(data));
    } catch (error) {
      console.log(log_error(error));
    }
  };
  componentDidUpdate(prevProps) {
    if (!prevProps.queue && this.props.queue) {
      this.fetchCurrentTrack();
      this.initNextUp();
    }
  }
  fetchCurrentTrack = async () => {
    let {
      queue: { loaded_media, queue, current_track_index }
    } = this.props;
    let current_track = loaded_media.find(
      m => m.id === queue[current_track_index]
    );
    if (current_track)
      this.props.dispatch(actions.setCurrentlyPlaying(current_track));
  };
  componentDidMount = async () => {
    await this.initQueue();
  };
  render = () => null;
}

export default connect(a => a)(QueueManager);
